__turbopack_context__.v({
  "black": "styles-module-scss-module__9gvG5G__black",
  "icon": "styles-module-scss-module__9gvG5G__icon",
  "root": "styles-module-scss-module__9gvG5G__root",
  "white": "styles-module-scss-module__9gvG5G__white",
});
